import {
  GET_ANOMALIES_SERVICE_REQUEST,
  GET_ANOMALIES_SERVICE_SUCCESS,
  GET_ANOMALIES_SERVICE_FAILURE,
  GET_ANOMALY_BY_ID_SERVICE_REQUEST,
  GET_ANOMALY_BY_ID_SERVICE_SUCCESS,
  GET_ANOMALY_BY_ID_SERVICE_FAILURE,
  UPDATE_ANOMALY_STATUS_SERVICE_REQUEST,
  UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS,
  UPDATE_ANOMALY_STATUS_SERVICE_FAILURE,
  UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST,
  UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS,
  UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE,
  DELETE_ANOMALY_SERVICE_REQUEST,
  DELETE_ANOMALY_SERVICE_SUCCESS,
  DELETE_ANOMALY_SERVICE_FAILURE,
} from "./actions";

const initialState = {
  anomalies: [],
  selectedAnomaly: null,
  loading: false,
  error: null,
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
};

export default function anomalyReducer(state = initialState, action) {
  switch (action.type) {
    // Anomali listesi
    case GET_ANOMALIES_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ANOMALIES_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        anomalies: action.payload,
        totalCount: action.payload.totalCount,
        currentPage: action.payload.currentPage,
        pageSize: action.payload.pageSize,
      };
    case GET_ANOMALIES_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Tek bir anomali getirme
    case GET_ANOMALY_BY_ID_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ANOMALY_BY_ID_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedAnomaly: action.payload,
      };
    case GET_ANOMALY_BY_ID_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Anomali durumu güncelleme
    case UPDATE_ANOMALY_STATUS_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_ANOMALY_STATUS_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        anomalies: state.anomalies.map((anomaly) =>
          anomaly.id === action.payload.id
            ? { ...anomaly, status: action.payload.status }
            : anomaly
        ),
      };
    case UPDATE_ANOMALY_STATUS_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Anomali seviyesi güncelleme
    case UPDATE_ANOMALY_LEVEL_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_ANOMALY_LEVEL_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        anomalies: state.anomalies.map((anomaly) =>
          anomaly.id === action.payload.id
            ? { ...anomaly, anomalyLevel: action.payload.anomalyLevel }
            : anomaly
        ),
      };
    case UPDATE_ANOMALY_LEVEL_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Anomali silme
    case DELETE_ANOMALY_SERVICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ANOMALY_SERVICE_SUCCESS:
      return {
        ...state,
        loading: false,
        anomalies: state.anomalies.filter(
          (anomaly) => anomaly.id !== action.payload
        ),
        totalCount: state.totalCount - 1,
      };
    case DELETE_ANOMALY_SERVICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
} 